function HeroSection() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-slate-900 text-white pt-32 pb-24 overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9d9b26888384a88cab3d6c654b8353ce.jpg"
          alt="Magome Kominka"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/85 via-slate-900/75 to-slate-900/90"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-500/15 border border-emerald-400/40 rounded-full mb-8 backdrop-blur-sm">
            <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
            <span className="text-sm font-medium text-emerald-300">現役ホストによる実務型サポート</span>
          </div>
          
          {/* Main Heading */}
          <h1 className="text-5xl lg:text-7xl font-bold mb-6 tracking-tight leading-tight">
            東京の民泊運営を、<br />
            <span className="text-emerald-400">プロに任せる</span>
          </h1>
          
          {/* Subheading */}
          <p className="text-xl lg:text-2xl text-slate-200 max-w-3xl mx-auto leading-relaxed mb-10">
            透明性の高い料金体系で、オーナー様の収益を最大化。<br />
            実践的なサポートで、安心の民泊運営を実現します。
          </p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-8 mb-12 text-center">
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-emerald-400 mb-1">95%+</div>
              <div className="text-sm text-slate-300">平均稼働率</div>
            </div>
            <div className="w-px h-12 bg-slate-600 hidden sm:block"></div>
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-emerald-400 mb-1">500+</div>
              <div className="text-sm text-slate-300">対応実績</div>
            </div>
            <div className="w-px h-12 bg-slate-600 hidden sm:block"></div>
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold text-emerald-400 mb-1">4.9/5</div>
              <div className="text-sm text-slate-300">お客様評価</div>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="/for-owners#contact"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-emerald-500 to-emerald-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              無料相談を予約する
            </a>
            <button
              onClick={scrollToPricing}
              className="inline-flex items-center gap-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-price-tag-3-line text-xl"></i>
              料金を見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;